import { Accordion, AccordionDetails, AccordionSummary, LinearProgress, Pagination, PaginationItem } from "@mui/material";
import { ArrowBack, Arrowdown2,  Forward } from "../../../assets";
import {  Layout, TableRowResponsive, EmptyTable, Button } from "../../components";
import { InstallmentController } from "../../controllers";
import { Helmet } from "react-helmet-async";
import moment from "moment-jalaali";
import { numberWithCommas } from "../../../core/utils";
import { toast } from "react-toastify";

class Installment extends InstallmentController {
  componentDidMount() {
    window.scrollTo(0, 0);
    this.getList()
  }
  render() {

    const {loading,installment} = this.state;
    return (
      <Layout title="اقساط ">
        <Helmet>
          <title> اقساط  | بیمه زندگی هامرز </title>
        </Helmet>

        {loading ? 
                <LinearProgress />
                :
                <>
        {/* <FilterInput buttonTitle="فیلتر ها" placeholder="فیلتر های اقساط " onClick={() => this.setState({ openModal: !this.state.openModal })} str={this.state.str} /> */}

        <div className="installment table-responsive scrollbar mt-5">
          <table className="table hide-mobile">
            <thead>
              <tr>
                <th scope="col"> شماره قسط  </th>
                <th scope="col"> سال </th>
                <th scope="col"> مبلغ </th>
                <th scope="col">تاریخ سررسید</th>

                <th scope="col"> مبلغ مازاد </th>
                <th scope="col"> مبلغ کل </th>

                <th scope="col">تاریخ واریز</th>
                <th scope="col"> پرداخت </th>
              </tr>
            </thead>
            <tbody>
              {installment?.list?.length > 0 && installment?.list?.map((item: any, index: number) => {
                return (

                  <tr>
                    <th>{item?.number}</th>
                    <td>{item?.year}</td>
                    <td>{numberWithCommas(item?.amount)}</td>
                    <td>{item?.expiry_date ? moment(`${item?.expiry_date}`, 'YYYY-M-D').format('jYYYY/jM/jD') : "---"}</td>

                    <td>{numberWithCommas(item?.extra_amount)}</td>
                    <td>{numberWithCommas(item?.total_amount)}</td>

                    <td>{item?.deposit_date ? moment(`${item?.deposit_date}`, 'YYYY-M-D').format('jYYYY/jM/jD') : "---"}</td>
                    <td>
                      
{item?.is_deposit ?
<Button myStyle="bg-blue table-btn" title=" واریز شده " onClick={()=>{}} />
:
<Button myStyle="bg-green table-btn" title="پرداخت" onClick={()=>{this.instalment(item?.id)}} />
}

                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
          {installment?.list?.length > 0 ? <>
            {installment?.list?.map((item: any, index: number) => {
              return (
                <>

                  <Accordion className="policy-accordion hide-desktop">
                    <AccordionSummary
                      expandIcon={<img alt="هامرز" src={Arrowdown2} />}
                      aria-controls="panel1a-content"
                      className="summsry"
                      id="panel1a-header"
                    >
                      <TableRowResponsive title=" شماره قسط " value={item?.number} />
                      <TableRowResponsive title="سال" value={item?.year} />
                      <TableRowResponsive title=" مبلغ	 " value={numberWithCommas(item?.amount)} />
                    </AccordionSummary>
                    <AccordionDetails
                      className="d-flex flex-wrap"
                    >
                      <TableRowResponsive title=" تاریخ سررسید " value={item?.expiry_date ? moment(`${item?.expiry_date}`, 'YYYY-M-D').format('jYYYY/jM/jD') : "---"} />
                      <TableRowResponsive title=" مبلغ مازاد   " value={numberWithCommas(item?.extra_amount)} />
                      <TableRowResponsive title="مبلغ کل	" value={numberWithCommas(item?.total_amount)} />
                    </AccordionDetails>
                    <AccordionDetails
                      className="d-flex flex-wrap"
                    >
                      <TableRowResponsive title=" تاریخ واریز	" value={item?.deposit_date ? moment(`${item?.deposit_date}`, 'YYYY-M-D').format('jYYYY/jM/jD') : "---"} />
                      <TableRowResponsive title=" پرداخت	" value={
                        <>
                        {item?.is_deposit ?
                          <Button myStyle="bg-blue table-btn" title=" واریز شده " onClick={()=>{}} />
                          :
                          <Button myStyle="bg-green table-btn" title="پرداخت" onClick={()=>{this.instalment(item?.id)}} />
                          }
                        </>
                      } />
                      
                    </AccordionDetails>
                  </Accordion>
                </>
              )
            })}
            <Pagination
              className="custom-pagination"
              count={installment?.total ? Math.ceil(installment?.total / 10) : 1}
              onChange={this.handleChangePage}
              size="small"
              page={this.state.page}
              renderItem={(item) => (
                <PaginationItem
                  slots={{ previous: Forward, next: ArrowBack }}
                  {...item}
                />
              )}
            />
          </>
            :
            <EmptyTable title="اطلاعاتی برای نمایش وجود ندارد" />
          }

        </div>
        </>
        }
      </Layout>
    )
  }
}
export default Installment;